module.exports = __webpack_public_path__ + "static/media/view9_bg4.b09d5989.png";